export default {
  openSidebar: (state) => {
    state.isSidebarOpen = true;
  },
  closeSidebar: (state) => {
    state.isSidebarOpen = false;
  },
  startLoading(state) {
    state.isLoading = true;
  },
  finishLoading(state) {
    state.isLoading = false;
  },
  showClassList(state) {
    state.isClassListVisible = true;
  },
  hideClassList(state) {
    state.isClassListVisible = false;
  },
};
